<template>
  <div v-if="isVisible" class="ao__mt">
    <div class="ao__media ao__media--16-9">
      <video v-if="asset && asset.urlWithProtocol" width="100%" height="100%" controls>
        <source :src="asset.urlWithProtocol" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</template>

<script setup lang="ts">
import type {PropType} from "vue";
import type AssetLocal from "~/libs/interfaces/AssetLocal";

const {
  asset
} = defineProps({
  asset: {type: Object as PropType<AssetLocal>, required: false}
})

const isVisible = ref(true)

const hide = () => {
  isVisible.value = false
}
</script>

<style lang="postcss" scoped>
</style>
